import { render, staticRenderFns } from "./ProjectTypeCombobox.vue?vue&type=template&id=5ace260b&"
import script from "./ProjectTypeCombobox.vue?vue&type=script&lang=js&"
export * from "./ProjectTypeCombobox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports